module.exports = __webpack_public_path__ + "img/x.ebf608bd.svg";